import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Quote } from 'lucide-react';
import { stories } from '../data/stories';
import { QuoteCard } from '../components/QuoteCard';
export function VerhaalDetail() {
  const {
    slug
  } = useParams();
  const story = stories.find(s => s.slug === slug);
  if (!story || !story.fullStory) {
    return <div className="container mx-auto px-4 py-16 text-center" data-id="element-1250">
        <h1 className="text-2xl font-bold mb-4" data-id="element-1251">Verhaal niet gevonden</h1>
        <Link to="/verhalen" className="text-gray-600 hover:underline" data-id="element-1252">
          ← Terug naar alle verhalen
        </Link>
      </div>;
  }
  const relatedStories = stories.filter(s => s.category === story.category && s.slug !== story.slug).slice(0, 2);
  return <div className="container mx-auto px-4 py-12" data-id="element-1253">
      <div className="max-w-3xl mx-auto" data-id="element-1254">
        <div className="mb-6" data-id="element-1255">
          <Link to="/verhalen" className="text-gray-600 hover:underline inline-flex items-center group" data-id="element-1256">
            <ArrowLeft size={16} className="mr-1 group-hover:-translate-x-1 transition-transform duration-200" data-id="element-1257" />
            Alle verhalen
          </Link>
        </div>

        {/* Hero image placeholder */}
        <div className="border-2 border-dashed border-gray-300 h-64 md:h-80 flex items-center justify-center bg-gray-100 rounded-lg mb-8" data-id="element-1258">
          <span className="text-gray-400" data-id="element-1259">Foto {story.name}</span>
        </div>

        {/* Quote highlight */}
        <div className="mb-8" data-id="element-1260">
          <Quote size={24} className="text-gray-300 mb-3" data-id="element-1261" />
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed italic mb-4" data-id="element-1262">
            "{story.quote}"
          </p>
          <div className="flex items-center" data-id="element-1263">
            <div className="border border-dashed border-gray-300 w-12 h-12 rounded-full flex items-center justify-center bg-gray-100 mr-3 flex-shrink-0" data-id="element-1264">
              <span className="text-gray-400 text-sm font-medium" data-id="element-1265">
                {story.name.charAt(0)}
              </span>
            </div>
            <div data-id="element-1266">
              <p className="font-medium text-gray-900" data-id="element-1267">{story.name}</p>
              <p className="text-sm text-gray-500" data-id="element-1268">{story.context}</p>
            </div>
          </div>
        </div>

        <hr className="border-gray-200 mb-8" data-id="element-1269" />

        {/* Full story */}
        <div className="prose prose-gray max-w-none" data-id="element-1270">
          {story.fullStory.split('\n\n').map((paragraph, i) => <p key={i} className="text-gray-600 leading-relaxed mb-6" data-id="element-1271">
              {paragraph}
            </p>)}
        </div>

        {/* Related stories */}
        {relatedStories.length > 0 && <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-1272">
            <h2 className="text-xl font-bold mb-6" data-id="element-1273">Meer verhalen</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1274">
              {relatedStories.map((s, i) => <QuoteCard key={i} story={s} data-id="element-1275" />)}
            </div>
          </div>}
      </div>
    </div>;
}